<div class="mb-1 border-solid border-b border-gray-300 bg-gray-100">
  <span class="text-gray-900 p-3 block text-md font-normal">{{
    tractor.name
  }}</span>
</div>

<div class="p-3" [ngSwitch]="selectedIndex">
  <div *ngSwitchCase="0" class="details">
    <div title="Position" class="head">Position</div>
    <div>
      <a
        target="_blank"
        href="https://www.google.com/maps/search/?api=1&query={{
          tractor.tracker.lat
        }},{{ tractor.tracker.lng }}"
        >{{ tractor.tracker.lat }},{{ tractor.tracker.lng }}</a
      >
    </div>
    <div title="Odomètre" class="head">Heures Moteur</div>
    <div>{{ tractor.tracker.engine_hours?.toFixed(2) }}</div>
    <div title="Odomètre" class="head">Odomètre</div>
    <div>{{ (tractor.tracker.odometer / 1000)?.toFixed(2) }}</div>
    <div title="IMEI" class="head">IMEI</div>
    <div>{{ tractor.tracker.imei }}</div>
    <div title="Marque" class="head">Marque</div>
    <div>{{ tractor.brand }}</div>
    <div title="Modèle" class="head">Modèle</div>
    <div>{{ tractor.model }}</div>
    <div title="Puissance" class="head">Puissance</div>
    <div>{{ tractor.engine_power }}</div>
    <div title="Matricule" class="head">Matricule</div>
    <div>{{ tractor.licence_plate }}</div>
    <div title="Année de production" class="head">Production</div>
    <div>{{ tractor.production_year }}</div>
    <div title="Position Serveur" class="head">Position Serveur</div>
    <div>{{ tractor.tracker.server_time | date: "yyyy-MM-dd HH:mm:ss" }}</div>
    <div title="Position Traceur" class="head">Position Traceur</div>
    <div>{{ tractor.tracker.tracker_time | date: "yyyy-MM-dd HH:mm:ss" }}</div>
    <ng-container *ngIf="tractor.tracker.is_pump">
      <ng-container *ngFor="let name of params; trackBy: trackParam">
        <div *ngIf="name == 'ADC5'" class="head">Pression</div>
        <div *ngIf="name == 'ADC5'">
          {{ tractor.tracker.params[name] * 10 * (40 / 5) }}
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div *ngSwitchCase="1">
    <dx-circular-gauge id="gauge" [value]="tractor.tracker.speed">
      <dxo-scale [startValue]="0" [endValue]="80" [tickInterval]="10">
        <dxo-label [useRangeColors]="true"></dxo-label>
      </dxo-scale>
      <dxo-range-container palette="pastel">
        <dxi-range [startValue]="0" [endValue]="17"></dxi-range>
        <dxi-range [startValue]="17" [endValue]="50"></dxi-range>
        <dxi-range [startValue]="50" [endValue]="80"></dxi-range>
      </dxo-range-container>
    </dx-circular-gauge>
  </div>

  <div *ngSwitchCase="2">
    <dx-scroll-view [height]="250" [useNative]="true" #scrollView>
      <div class="details">
        <ng-container *ngFor="let name of params; trackBy: trackParam">
          <div class="head">{{ name }}</div>
          <div>{{ tractor.tracker.params[name] }}</div>
        </ng-container>
      </div>
    </dx-scroll-view>
  </div>
</div>

<div class="border-t border-gray-300 border-solid">
  <dx-tabs
    [dataSource]="tabs"
    [(selectedIndex)]="selectedIndex"
    [width]="300"
    (onItemClick)="selectTab($event)"
    [scrollByContent]="true"
    [showNavButtons]="true"
  ></dx-tabs>
</div>
